import { css } from "@emotion/core"
import { FC } from "react"
import { Box, Center, Stack, Switcher, Text } from "../common"

export const CityWhyUs: FC<any> = props => {
  return (
    <Box id="home-why-us">
      <Center gutters="var(--s2)" maxWidth="var(--max-width)">
        <Stack space="var(--s3)">
          <Text
            style={{ textTransform: "uppercase" }}
            variant="h2"
            css={css`
              @media screen and (max-width: 600px) {
                text-align: center;
              }
            `}
          >
            Features & Benefits
          </Text>
          <Switcher max={4} threshold="var(--min-width)" space="var(--s1)">
            {props.features.map(item => (
              <Stack space="var(--s1)" align="center">
                {item.icon}
                <Stack space="var(--s-2)" align="center">
                  <Text variant="h4">{item.title}</Text>
                  <Text
                    color="light"
                    style={{ textAlign: "center" }}
                    variant="p"
                  >
                    {item.content}
                  </Text>
                </Stack>
              </Stack>
            ))}
          </Switcher>
        </Stack>
      </Center>
    </Box>
  )
}